module.exports = __webpack_public_path__ + "images/FUSA_icons/016-exchange.c8f0fda3f604b149da8167c6285338f3.svg";